// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import OptimizedImage from 'components/atoms/OptimizedImage'
import Path from 'routes/path'
import { type Room as RoomType } from 'types/room'

export const Container = styled.div`
  border: 1px solid ${Colors.grayD};
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
`

const Thumbnail = styled.div`
  overflow: hidden;
  width: 100%;
  height: auto;
`

export const Title = styled.h1`
  padding: 8px 16px;
  line-height: 1.4;
  font-weight: bold;
  color: ${Colors.black};
`

export default (props: RoomType) => (
  <a href={Path.room(props.space.username, props.uid)}>
    <Container>
      <Thumbnail>
        <OptimizedImage
          src={
            Array.isArray(props.thumbnails) && props.thumbnails.length > 0
              ? props.thumbnails.results[0].url
              : ''
          }
          alt={props.name}
          type="flex"
        />
      </Thumbnail>
      <Title>{props.pageTitle}</Title>
    </Container>
  </a>
)



// WEBPACK FOOTER //
// ./src/components/molecules/ReviewRoomCard/index.jsx